import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import React, { FC } from 'react';
import BaseSliderControl from './BaseSlideControl';

// NOTE: we need to pass any here as react-slick custom arrows doesn't send props as usual
const PrevSliderButton: FC<any> = props => (
  <BaseSliderControl {...props}>
    <ArrowBackIosIcon data-test="stockLite:slider:prev" />
  </BaseSliderControl>
);

export default PrevSliderButton;
